import { shortAddress } from '../core/format'
import { Copyable } from './Formatting'

export function Address({ value }: { value: string }) {
  if (!value) return <span className="muted">Unknown</span>
  return <Copyable value={value} label="Copy address" display={<code className="ui-address" title={value}>{shortAddress(value)}</code>} />
}
